import { createSelector } from 'reselect';

const getCartTax = cart => cart.summary.tax;
const getCartTotal = cart => cart.summary.total;
const getCartSubTotal = cart => cart.summary.subtotal;
const getCartItemsCount = cart => cart.summary.items_count;
const getCartShipping = cart => cart.summary.shipping;

const getCartSummary = createSelector(
  [
    getCartTax,
    getCartTotal,
    getCartSubTotal,
    getCartItemsCount,
    getCartShipping,
  ],
  (tax, total, subtotal, itemsCount, shipping) => ({
    tax,
    total,
    subtotal,
    itemsCount,
    shipping,
  })
);

const cartSelector = state => state.data.cart;

export const getCartStatus = state => state.status.cart;
export const getCartItemsStatus = state => state.status.cartItems;

export default createSelector(cartSelector, cart => {
  return cart
    ? {
      id: cart.id,
      itemsCount: cart.items_count,
      items: cart.items,
      ...getCartSummary(cart),
    }
    : null;
});



// WEBPACK FOOTER //
// ./src/selector/cart.js